import classNames from 'classnames'
import {SvgIcon} from './SvgIcon'

export const LawScaleIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = '',
  ariaLabel,
  datacy,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    aria-label={ariaLabel}
    data-cy={datacy}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(classes, {
      'text-gray-1000 fill-dope-black': !classes,
    })}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 21h13M12 21V7m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2-1.8c3.073.661 2.467 2.8 5 2.8M5 8c3.359 0 2.192-2.115 5.012-2.793M7 9.556V7.75m0 1.806-1.95 4.393a.773.773 0 0 0 .37.962.785.785 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.776.776 0 0 0 .09-.716L7 9.556Zm10 0V7.313m0 2.243-1.95 4.393a.773.773 0 0 0 .37.962.786.786 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.775.775 0 0 0 .09-.716L17 9.556Z"
    />
  </svg>
)

export const FileIcon: SvgIcon = ({
  width = 16,
  height = 16,
  classes = 'text-gray-1000',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    aria-label={ariaLabel}
    data-cy={datacy}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M5.16634 12.8334H10.833C11.5694 12.8334 12.1663 12.2365 12.1663 11.5001V6.00008L9.33301 3.16675H5.16634C4.42996 3.16675 3.83301 3.7637 3.83301 4.50008V11.5001C3.83301 12.2365 4.42996 12.8334 5.16634 12.8334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0003 6.16659H9.16699V3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SSPMWarningTriangleIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M4.95203 16.3535L10.215 5.85653C10.953 4.38476 13.0537 4.38515 13.7911 5.85718L19.0493 16.3542C19.7155 17.6841 18.7485 19.25 17.2611 19.25H6.73989C5.25216 19.25 4.28523 17.6835 4.95203 16.3535Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z"
      stroke="currentColor"
    />
  </svg>
)

export const SSPMKeyIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M15 13.25C17.3472 13.25 19.25 11.3472 19.25 9C19.25 6.65279 17.3472 4.75 15 4.75C12.6528 4.75 10.75 6.65279 10.75 9C10.75 9.31012 10.7832 9.61248 10.8463 9.90372L4.75 16V19.25H8L8.75 18.5V16.75H10.5L11.75 15.5V13.75H13.5L14.0963 13.1537C14.3875 13.2168 14.6899 13.25 15 13.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 7.5C16.2761 7.5 16.5 7.72386 16.5 8C16.5 8.27614 16.2761 8.5 16 8.5C15.7239 8.5 15.5 8.27614 15.5 8C15.5 7.72386 15.7239 7.5 16 7.5Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
)

export const SSPMLockUnlockedIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M5.75 11.75C5.75 11.1977 6.19772 10.75 6.75 10.75H17.25C17.8023 10.75 18.25 11.1977 18.25 11.75V17.25C18.25 18.3546 17.3546 19.25 16.25 19.25H7.75C6.64543 19.25 5.75 18.3546 5.75 17.25V11.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.74972 10.5V9.84343C7.74972 8.61493 7.70065 7.29883 8.42388 6.30578C8.99835 5.51699 10.0565 4.75 11.9997 4.75C13.9997 4.75 15.2497 6.25 15.2497 6.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SSPMTrendingDownIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M19.25 10.25L13.75 4.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.75 19.2502H18.25C18.8023 19.2502 19.25 18.8025 19.25 18.2502V15.75C19.25 15.1977 18.8023 14.75 18.25 14.75H17.75C17.1977 14.75 16.75 15.1977 16.75 15.75V18.2502C16.75 18.8025 17.1977 19.2502 17.75 19.2502Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.75 19.2502H12.25C12.8023 19.2502 13.25 18.8025 13.25 18.2502V12.75C13.25 12.1977 12.8023 11.75 12.25 11.75H11.75C11.1977 11.75 10.75 12.1977 10.75 12.75V18.2502C10.75 18.8025 11.1977 19.2502 11.75 19.2502Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 19.2502H6.25C6.80229 19.2502 7.25 18.8025 7.25 18.2502V5.75C7.25 5.19772 6.80229 4.75 6.25 4.75H5.75C5.19772 4.75 4.75 5.19772 4.75 5.75V18.2502C4.75 18.8025 5.19772 19.2502 5.75 19.2502Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 6.75V10.25H15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SSPMUserCrossIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M15.25 8C15.25 9.79493 13.7949 11.25 12 11.25C10.2051 11.25 8.75 9.79493 8.75 8C8.75 6.20507 10.2051 4.75 12 4.75C13.7949 4.75 15.25 6.20507 15.25 8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2502 19.25H6.94974C5.77025 19.25 4.8901 18.2103 5.49106 17.1954C6.36268 15.7234 8.23956 14 12.2502 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 19.25L15.75 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 19.25L19.25 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SSPMCheckCircleIcon: SvgIcon = ({
  width = 24,
  height = 24,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 12.75L10.1837 13.6744C10.5275 14.407 11.5536 14.4492 11.9564 13.7473L14.25 9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FilterFunnelIcon: SvgIcon = ({
  width = 13,
  height = 13,
  classes = 'text-gray-500',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      d="M11.9163 1.625H1.08301L5.41634 6.74917V10.2917L7.58301 11.375V6.74917L11.9163 1.625Z"
      stroke="currentColor"
      strokeWidth="1.08333"
    />
  </svg>
)

export const ExternalLinkIcon: SvgIcon = ({
  width = 12,
  height = 12,
  classes = 'text-white',
  ariaLabel,
  datacy,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
  >
    <path
      id="Vector"
      d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
